import { Dispatch, connect } from 'react-redux';
import { AppState } from 'src';
import { resendDocument, getDocumentHistory } from 'src/document-history/document-history.actions';
import { DocumentResendComponentProperties, DocumentResendComponent } from './document-resend.component';
import { toggleModal } from '@common/components/common.actions';

interface DocumentResendProperties {
  readonly isFailedEmail?: boolean;
  readonly entityId?: number;
}

function mapStateToProps(
  state: AppState,
  ownProps: DocumentResendProperties
): Partial<DocumentResendComponentProperties> {
  return {
    entityId: ownProps.isFailedEmail ? ownProps.entityId : state.documentHistory.entityId
  };
}

function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: DocumentResendProperties
): Partial<DocumentResendComponentProperties> {
  return {
    resendEmail: async (emailHistoryId: number, entityId: number, emailAddress?: string) => {
      await dispatch(resendDocument(emailHistoryId, entityId, emailAddress));
      dispatch(toggleModal());
      if (!ownProps.isFailedEmail) {
        await dispatch(getDocumentHistory(entityId));
      }
    }
  };
}

export const DocumentResend = connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentResendComponent);



// WEBPACK FOOTER //
// ./src/document-history/_components/document-resend/document-resend.container.ts